import { processServicesData } from 'helpers/global-search'
import { getGlobalSearchDisplay } from '../../selectors'
import resultBlockHoc from '../resultBlockHoc'
import Service from '../Service'
import SortableResultList from '../SortableResultList'

const mapStateToProps = state => ({
  displayGlobalSearch: getGlobalSearchDisplay(state)
})

export default resultBlockHoc({
  TileComponent: Service,
  blockName: 'Service',
  mapStateToProps,
  processData: processServicesData,
  type: 'BOTServicesSearchResults'
})(SortableResultList)
